import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  buildingsTableContainer: {},
  wrapper: {
    position: 'relative'
  },
  noData: {
    color: palette.shades[700]
  },
  row: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  rightAlign: {
    textAlign: 'right'
  },
  firstColumn: {
    width: '398px',
    maxWidth: '398px'
  },
  cellContent: {
    padding: '10px 6px',
    borderRadius: '2px',
    transition: "all ".concat(palette.transitions.short),
    width: '100%',
    height: '36px',
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    transition: "all ".concat(palette.transitions.short),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: palette.shades[200]
    }
  },
  statusInfo: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    textAlign: 'left'
  },
  propertyAddress: {
    whiteSpace: 'nowrap',
    maxWidth: '230px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    marginLeft: '10px',
    '&.fullWidth': {
      maxWidth: '100%'
    }
  },
  enrollmentDateWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  enrollmentDate: {
    width: '76px',
    marginLeft: '20px'
  },
  todoDropdown: {
    marginLeft: '4px'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  demoBlock: {
    padding: '32px 40px',
    background: palette.gradients.white,
    boxShadow: palette.shadows.light,
    borderRadius: '0 0 2px 2px',
    marginTop: '2px'
  },
  toolboxWrapperHeader: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  }
}));
export default useStyles;